import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-links">
            <Link to="/terms" className="footer-link">Terms & Conditions</Link>
            <span className="separator">|</span>
            <Link to="/refund" className="footer-link">Refund Policy</Link>
            <span className="separator">|</span>
            <Link to="/returns" className="footer-link">Return Policy</Link>
            <span className="separator">|</span>
            <Link to="/shipping" className="footer-link">Shipping Policy</Link>
            <span className="separator">|</span>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          </div>
          <p className="copyright">© 2025 BUNNY BOBA LLP</p>
        </div>
      </div>
      
      <style jsx>{`
        .footer {
          background: linear-gradient(45deg, #E91E63, #FF1493);
          color: white;
          padding: 20px 0;
          margin-top: auto;
          text-align: center;
          border-top: 3px solid #C2185B;
        }
        
        .footer-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }

        .footer-links {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .footer-link {
          color: white;
          text-decoration: none;
          font-size: 0.9rem;
          font-weight: 500;
          transition: color 0.3s ease;
        }

        .footer-link:hover {
          color: #ffb3d6;
          text-decoration: underline;
        }

        .separator {
          color: white;
          font-weight: 300;
        }
        
        .copyright {
          font-size: 1rem;
          font-weight: 600;
          margin: 0;
          letter-spacing: 0.5px;
        }
        
        @media (max-width: 768px) {
          .footer {
            padding: 15px 0;
          }
          
          .footer-links {
            flex-direction: column;
            gap: 10px;
          }

          .separator {
            display: none;
          }
          
          .footer-link {
            font-size: 0.8rem;
          }
          
          .copyright {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer; 